export default __webpack_public_path__ + "static/media/DisAlignTop.7b0fb64a.svg";